'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = FormField;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _validation = require('./validation');

var _validation2 = _interopRequireDefault(_validation);

require('./form-field.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function FormField(Component) {
  var formField = function (_React$Component) {
    _inherits(formField, _React$Component);

    function formField(props) {
      _classCallCheck(this, formField);

      var _this = _possibleConstructorReturn(this, (formField.__proto__ || Object.getPrototypeOf(formField)).call(this, props));

      _this.state = {
        isFocused: false
      };
      _this.onFocusHandler = _this.onFocusHandler.bind(_this);
      _this.onBlurHandler = _this.onBlurHandler.bind(_this);
      return _this;
    }

    _createClass(formField, [{
      key: 'onBlurHandler',
      value: function onBlurHandler(event) {
        this.setState({ isFocused: false });

        // This is for the redux-form
        if (this.props.onBlur) {
          this.props.onBlur(event);
        }
      }
    }, {
      key: 'onFocusHandler',
      value: function onFocusHandler(event) {
        this.setState({ isFocused: true });

        // This is for the redux-form
        if (this.props.onFocus) {
          this.props.onFocus(event);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            size = _props.size,
            state = _props.state,
            style = _props.style,
            className = _props.className,
            label = _props.label,
            showValidation = _props.showValidation,
            props = _objectWithoutProperties(_props, ['size', 'state', 'style', 'className', 'label', 'showValidation']);

        var onFocus = props.onFocus,
            onBlur = props.onBlur,
            validationMessage = props.validationMessage,
            validationMessageTemplate = props.validationMessageTemplate,
            propsToPropagate = _objectWithoutProperties(props, ['onFocus', 'onBlur', 'validationMessage', 'validationMessageTemplate']);

        var labelClasses = (0, _classnames2.default)('field-label', className);
        var inputWrapperClasses = (0, _classnames2.default)('field-wrapper', 'field-wrapper--' + size, label && 'field-wrapper--has-label', props.readOnly && 'field-wrapper--readonly', state && 'field-wrapper--' + state, showValidation && 'field-wrapper--show-validation', this.state.isFocused && 'field-wrapper--focused');
        var inputClasses = (0, _classnames2.default)('field', props.readOnly && 'field--readonly');

        return _react2.default.createElement(
          'label',
          { className: labelClasses, style: style },
          label,
          _react2.default.createElement(
            'span',
            { className: inputWrapperClasses },
            _react2.default.createElement(Component, _extends({
              className: inputClasses,
              onFocus: this.onFocusHandler,
              onBlur: this.onBlurHandler
            }, propsToPropagate))
          ),
          _react2.default.createElement(_validation2.default, {
            validationMessageTemplate: validationMessageTemplate,
            validationMessage: validationMessage,
            state: state
          })
        );
      }
    }]);

    return formField;
  }(_react2.default.Component);

  formField.propTypes = {
    className: _propTypes2.default.string,
    label: _propTypes2.default.string,
    size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'x-large']),
    style: _propTypes2.default.object,
    readOnly: _propTypes2.default.bool,
    showValidation: _propTypes2.default.bool,
    onBlur: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    validationMessage: _propTypes2.default.string,
    validationMessageTemplate: _propTypes2.default.func,
    state: _propTypes2.default.oneOf(['success', 'error', 'warning', 'hint'])
  };

  formField.defaultProps = {
    size: 'medium',
    showValidation: false
  };

  return formField;
}